import React from "react"
import { truncateString } from "../../utils/commonUtils"

const TruncatedTextWithTooltip = ({
   text,
   characterLimit = 30,
   fallbackText = "-",
}) => {
   const displayText = text || fallbackText

   if (displayText.length > characterLimit) {
      return (
         <div className="tooltip-container">
            <div>{truncateString(displayText, characterLimit)}</div>
            <span className="custom-tooltip">{displayText}</span>
         </div>
      )
   }

   return <>{displayText}</>
}

export default TruncatedTextWithTooltip
